<template>
  <div class="background-img">
    <span class="mask bg-gradient-indigo"></span>
    <div class="centered-text">
      <div class="main-heading">Welcome to the Tarana Private Portal.</div>
      <div class="sub-heading">
        Everything you need to get the most out of your network
      </div>
    </div>
  </div>

  <div class="container d-flex flex-column home gap-3">
    <div class="row set-margin">
      <div class="col-sm-12 col-md-6 mb-4" v-if="showOnboarding == 'true'">
        <router-link to="/onboarding/cto" class="text-dark">
          <div class="card card-bg">
            <div class="card-body">
              <h5 class="card-title">
                <img
                  src="../assets/images/icons/book.svg"
                  alt="New to Tarana?"
                  class="d-inline-block align-text-top pad-right"
                />
                New to Tarana?
              </h5>
              <p class="card-text">
                Quickly access essential tools and resources to begin your
                journey.
              </p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-sm-12 col-md-6 mb-4">
        <router-link :to="{ path: '/resources' }" class="text-dark">
          <div class="card card-bg">
            <div class="card-body">
              <h5 class="card-title">
                <img
                  src="../assets/images/icons/folder-opened.svg"
                  alt="Resources"
                  class="d-inline-block align-text-top pad-right"
                />
                Resources
              </h5>
              <p class="card-text">
                Access secure internal tools, documents and more.
              </p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-sm-12 col-md-6 mb-4">
        <a href="https://taranawireless.com/training/" class="text-dark">
          <div class="card card-bg">
            <div class="card-body">
              <h5 class="card-title">
                <img
                  src="../assets/images/icons/presentation.svg"
                  alt="Training"
                  class="d-inline-block align-text-top pad-right"
                />
                Training
              </h5>
              <p class="card-text">
                Learn about products, access training and certifications.
              </p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-sm-12 col-md-6 mb-4">
        <a href="https://tcs.taranawireless.com" class="text-dark">
          <div class="card card-bg">
            <div class="card-body">
              <h5 class="card-title">
                <img
                  src="../assets/images/icons/broadcasting.svg"
                  alt="Tarana Cloud Suite (TCS)"
                  class="d-inline-block align-text-top pad-right"
                />
                Tarana Cloud Suite (TCS)
              </h5>
              <p class="card-text">
                Manage devices, network and cloud operations.
              </p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="row mt-3 home" v-if="currentUser && resourceList.length > 0">
      <div class="col-sm-12 heading">
        Download resources
        <router-link
          to="/resources"
          class="resource-link float-end d-none d-sm-block"
          >View all resources <i class="fa fa-arrow-right arrow"></i
        ></router-link>
        <hr />
      </div>
      <div class="col-sm-12" v-if="resourceList.length > 0">
        <swiper
          ref="mySwiper"
          :slides-per-view="4"
          :autoplay="autoplay"
          :space-between="20"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          :height="150"
          :breakpoints="breakpoints"
        >
          <swiper-slide v-for="(resource, index) in resourceList" :key="index">
            <div class="col-sm-12">
              <div class="card swiper-card">
                <div class="card-body">
                  <h5 class="card-title">
                    {{
                      resource.name.length > 25
                        ? resource.name.slice(0, 25) + "..."
                        : resource.name
                    }}
                  </h5>
                  <p
                    class="card-text"
                    v-html="$sanitize(formatDescription(resource.description))"
                  ></p>
                  <div class="card-pdf">
                    <span class="pdf-text" v-if="resource.file_name"
                      >{{ getFileType(resource.file_name) }} |
                      {{
                        resource.file_size / (1024 * 1024) < 1
                          ? "<1"
                          : (resource.file_size / (1024 * 1024)).toFixed()
                      }}
                      MB</span
                    >
                  </div>
                  <div class="card-download" v-if="resource.file_name">
                    <a
                      :href="`${getAPIUrl}/storage/${resource.file_path}`"
                      @click="resourceAction(resource)"
                      class="pdf-text"
                      target="_blank"
                      ><i class="fa fa-download"></i
                    ></a>
                  </div>
                  <div class="card-download" v-if="resource.resource_link">
                    <a
                      :href="resource.resource_link"
                      @click="resourceAction(resource)"
                      class="pdf-text"
                      target="_blank"
                      ><i class="fa fa-eye"></i
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="col-sm-12 text-center d-block d-sm-none mt-4">
        <router-link to="/resources" class="resource-link"
          >View all resources <i class="fa fa-arrow-right"></i
        ></router-link>
      </div>
    </div>
  </div>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay } from "swiper";
SwiperCore.use([Autoplay]);

// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      resourceList: [],
      resourcePermissions: [],
      categories: [],
      subcategories: [],
      isSmallScreen: false,
      showOnboarding: process.env.VUE_APP_CUSTOMER_ONBOARDING,
      breakpoints: {
        280: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    };
  },
  computed: {
    getAPIUrl() {
      const base = this.$axios.defaults.baseURL;
      return base.split("/api")[0];
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  setup() {
    const onSwiper = (swiper) => {};
    const onSlideChange = () => {};
    return {
      onSwiper,
      onSlideChange,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
    };
  },
  mounted() {
    if (this.currentUser) {
      this.getPermissions();
      this.getResources();
    }
    this.updateActions("/home");
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    this.isSmallScreen = mediaQuery.matches;
    mediaQuery.addEventListener("change", this.handleScreenSizeChange);
  },
  beforeDestroy() {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    mediaQuery.removeEventListener("change", this.handleScreenSizeChange);
  },
  methods: {
    handleScreenSizeChange(event) {
      this.isSmallScreen = event.matches;
    },
    getFileType(fileName) {
      let ext = "";
      if (fileName != "") {
        const extension = fileName.split(".").pop();
        ext = extension.toUpperCase();
      }
      return ext;
    },
    resourceAction(resource) {
      let actionJson = {};
      if (resource.resource_link) {
        actionJson = {
          pagelink: resource.resource_link,
        };
      } else {
        const paddedNumber = resource.id.toString().padStart(4, "0");
        let pagelink = `lib${paddedNumber}: ${resource.name}`;
        actionJson = {
          pagelink: pagelink,
          action: "downloaded",
          contentClass: "libe entry",
        };
      }

      let userId = this.currentUser.user.id;
      if (userId) {
        actionJson.userId = userId;
        actionJson.sessionId = this.currentUser.sessionId;
      }

      this.$axios
        .post("action-update", actionJson)
        .then(function (response) {});
    },
    formatDescription(description) {
      if (description && description.length > 60) {
        return `${description.slice(0, 60)}...`;
      } else {
        return description;
      }
    },
    getPermissions() {
      let entityClassId = this.currentUser.user.entity
        ? this.currentUser.user.entity.entity_class_id
        : null;
      let userId = this.currentUser.user.id;
      this.$axios
        .post("resource/permissions/" + userId, {
          entityClassId: entityClassId,
        })
        .then(
          function (response) {
            const permissions = response.data.permissions || [];

            if (permissions.length > 0) {
              this.resourcePermissions = permissions;
            }
          }.bind(this)
        );
    },
    getResources() {
      let loader = this.$loading.show({
        canCancel: true,
        color: "#0367a9",
      });
      this.$axios.get("resources", {}).then(
        function (response) {
          loader.hide();
          this.categories = response.data;
          for (let i = 0; i < this.categories.length; i++) {
            if (this.categories[i].resources.length > 0) {
              this.categories[i].resources.forEach((resource) => {
                if (this.checkResourcePermission(resource.id)) {
                  this.resourceList.push(resource);
                }
              });
            }

            this.subcategories = [];
            if (this.categories[i].subcategories.length > 0) {
              this.subcategories = this.categories[i].subcategories;
              for (let j = 0; j < this.subcategories.length; j++) {
                if (this.subcategories[j].resources.length > 0) {
                  this.subcategories[j].resources.forEach((resource) => {
                    if (this.checkResourcePermission(resource.id)) {
                      this.resourceList.push(resource);
                    }
                  });
                }
              }
            }
          }
        }.bind(this)
      );
    },
    checkResourcePermission(resourceId) {
      return this.currentUser && this.resourcePermissions.includes(resourceId);
    },
  },
};
</script>
